import { Language } from "@app/provider";
import { IntlShape } from "react-intl";

export const getFormattedMonthlyPaymentDate = (
  intl: IntlShape,
  date: Date
): string => {
  const day = date.getDate();

  const daySuffix = getOrdinalSuffix(day, intl);

  return daySuffix;
};

export const getOrdinalSuffix = (number: number, intl: IntlShape): string => {
  if (intl.locale === Language.ES) {
    if ([1, 3].includes(number)) return `${number}er`;
    if (number === 2) return "2do";
    if ([4, 5, 6].includes(number)) return `${number}to`;
    if (number === 7) return "7mo";
    if ([8, 11, 12].includes(number)) return `${number}vo`;
    if (number === 9) return "9no";
    if (number === 10) return "10mo";

    return `${number}º`;
  }

  if (number > 3 && number < 21) return `${number}th`;
  switch (number % 10) {
    case 1:
      return `${number}st`;
    case 2:
      return `${number}nd`;
    case 3:
      return `${number}rd`;
    default:
      return `${number}th`;
  }
};
